module.exports = __webpack_public_path__ + "static/media/dashboard.620704c5.svg";